import type { CockpitRailSegment } from '../model/cockpitViewModel';
import { useCockpitStyles } from './cockpitStyles';
import { segmentAccessibleName } from './evidenceRailPresentation';

export interface EvidenceRailSegmentProps {
  segment: CockpitRailSegment;
  selected: boolean;
  onSelect: (nodeId: string) => void;
}

export const EvidenceRailSegment = ({
  segment,
  selected,
  onSelect,
}: EvidenceRailSegmentProps) => {
  const classes = useCockpitStyles();
  const stateClassName = `${classes.segment} ${classes[segment.state]}`;
  const accessibleName = segmentAccessibleName(segment);
  const nodeId = segment.nodeId;

  if (!nodeId) {
    return (
      <span
        role="img"
        aria-label={accessibleName}
        className={`${stateClassName} ${classes.segmentPassive}`}
        data-rail-state={segment.state}
      />
    );
  }

  return (
    <button
      type="button"
      className={`${stateClassName} ${selected ? classes.railSelected : ''}`}
      data-rail-state={segment.state}
      aria-label={accessibleName}
      aria-pressed={selected}
      onClick={() => onSelect(nodeId)}
    />
  );
};
